// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import i18n from '../../i18n/i18n'
import 'jquery'
import download from "../../../static/js/download.js";
import ElementUI from 'element-ui' // 引入EelmentUI组件
import 'element-ui/lib/theme-chalk/index.css'
// import '../../assets/iconfont/iconfont.css'
import 'font-awesome/css/font-awesome.css'
import axios from 'axios';
import echarts from 'echarts'
import App from './App'
import router, { addRouter } from './router'
import crypto from "crypto-js";
import Vant from 'vant';
import { Dialog } from 'vant';
import { Lazyload } from 'vant';
import { areaList } from '@vant/area-data';
import 'vant/lib/index.css';
import { Area } from 'vant';
// import VideoPlayer from 'vue-video-player'
import '../../../static/fontFamily/font.css'
// import 'video.js/dist/video-js.css' // css 一定要引入
import JSEncrypt from 'jsencrypt'
import Encrypt from 'encryptlong'
import VueMoment from "vue-moment";
import moment from "moment";
import dayjs from "dayjs"
// Vue.use(VideoPlayer) // 挂载到vue上

Vue.directive('loadmore', {
    bind(el, binding) {
        const selectWrap = el.querySelector('.el-table__body-wrapper')
        selectWrap.addEventListener('scroll', function() {
            let sign = 10
            const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
            if (scrollDistance <= sign) {
                binding.value()
            }
        })
    }
})

Vue.use(Vant);


Vue.use(Dialog);
Vue.use(areaList);
Vue.use(Lazyload);
Vue.use(Area);
Vue.use(VueMoment, { moment });
Vue.prototype.$dayjs = dayjs;
Vue.prototype.$echarts = echarts;
//axios.defaults.baseURL = config.SERVICE_CONTEXT_PATH; // 配置axios全局请求地址
axios.defaults.timeout = 30000;
axios.interceptors.request.use((config) => {
    if (config.url != "https://restapi.amap.com/v3/config/district?parameters") {
        if (window.sessionStorage.getItem("token") != null) {
            //为请求头对象，添加token 验证的 Authorization 字段
            config.headers.Authorization = "Bearer " + window.sessionStorage.getItem("token");
        }
    }
    //在最后必须 return config
    config.retry = 10
    config.retryDelay = 1000
    console.log(config);
    return config;
}, function(error) {
    if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
        console.log("请求超时");
    } else {
        console.log("其他错误", error);
    }
    return Promise.reject(error);
});

axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
    var config = err.config;
    // If config does not exist or the retry option is not set, reject
    if (!config || !config.retry) return Promise.reject(err);
    // Set the variable for keeping track of the retry count
    config.__retryCount = config.__retryCount || 0;
    // Check if we've maxed out the total number of retries
    if (config.__retryCount >= config.retry) {
        // Reject with the error
        return Promise.reject(err);
    }
    // Increase the retry count
    config.__retryCount += 1;
    // Create new promise to handle exponential backoff
    var backoff = new Promise(function(resolve) {
        setTimeout(function() {
            resolve();
        }, config.retryDelay || 1);
    });
    // Return the promise in which recalls axios to retry the request
    return backoff.then(function() {
        return axios(config);
    });
});
Vue.prototype.$axios = axios;
Vue.config.productionTip = false
Vue.prototype.$download = download;
Vue.prototype.$store = store;
Vue.prototype.$crypto = crypto;
Vue.prototype.$JSEncrypt = JSEncrypt;
Vue.prototype.$Encrypt = Encrypt;
Vue.prototype.$mapData = [{
        value: "113.983316,22.883915",
        label: "黄江镇"
    },
    {
        value: "114.065029,23.031536",
        label: "桥头镇"
    },
    {
        value: "114.109028,22.864049",
        label: "清溪镇"
    },
    {
        value: "113.606888,23.015507",
        label: "洪梅镇"
    },
    {
        value: "113.772920,23.100117",
        label: "高埗镇"
    },
    {
        value: "113.616702,23.088653",
        label: "麻涌镇"
    },
    {
        value: "114.057782,22.833564",
        label: "塘厦镇"
    },
    {
        value: "113.714249,23.004871",
        label: "万江街道"
    },
    {
        value: "113.675238,23.067562",
        label: "望牛墩镇"
    },
    {
        value: "113.687246,23.004094",
        label: "道滘镇"
    },
    {
        value: "113.756157,23.026359",
        label: "莞城街道"
    },
    {
        value: "113.989933,23.054588",
        label: "企石镇"
    },
    {
        value: "114.015449,22.869270",
        label: "樟木头镇"
    },
    {
        value: "113.921005,22.989113",
        label: "东坑镇"
    },
    {
        value: "113.806239,22.948285",
        label: "大岭山镇"
    },
    {
        value: "113.768809,22.941355",
        label: "南城街道"
    },
    {
        value: "114.171775,22.984642",
        label: "谢岗镇"
    },
    {
        value: "113.772060,22.941938",
        label: "东城街道"
    },
    {
        value: "114.041069,23.007892",
        label: "常平镇"
    },
    {
        value: "114.139781,22.777948",
        label: "凤岗镇"
    },
    {
        value: "113.947048,22.865074",
        label: "大朗镇"
    },
    {
        value: "113.917593,22.981271",
        label: "寮步镇"
    },
    {
        value: "114.030270,23.035086",
        label: "横沥镇"
    },
    {
        value: "113.582201,22.942601",
        label: "沙田镇"
    },
    {
        value: "113.989827,23.069114",
        label: "石排镇"
    },
    {
        value: "113.840966,23.092760",
        label: "茶山镇"
    },
    {
        value: "113.612748,23.042585",
        label: "中堂镇"
    },
    {
        value: "113.802243,22.838519",
        label: "长安镇"
    },
    {
        value: "113.631616,22.934094",
        label: "厚街镇"
    },
    {
        value: "113.631506,22.832134",
        label: "虎门镇"
    },
    {
        value: "113.772148,23.095617",
        label: "石碣镇"
    },
    {
        value: "113.859745,23.087788",
        label: "石龙镇"
    },
    {
        value: "113.881439,22.894260",
        label: "松山湖"
    },
    {
        value: "113.756508,22.769739",
        label: "滨海湾"
    },
];


Vue.use(ElementUI)


//获取角色信息，根据用户权限动态加载路由
router.beforeEach((to, from, next) => {

    let storage = window.sessionStorage;
    let token = storage.getItem("token"); // 保存用户登录信息
    let url = to.path;
    let path = url.substring(0, 4)
    if (token) {
        if (url === '/login') {
            next({ path: '/' })
        } else {
            if (!store.getters.info.role) {
                !async function getAddRouters() {
                    // 省略 axios 请求代码 通过 token 向后台请求用户权限等信息，这里用假数据赋值
                    const menus = JSON.parse(storage.getItem('menus') || "[]")
                    await store.dispatch('getInfo', {
                        role: 'admin',
                        permissions: '管理员'
                    })

                    // 增加路由菜单 暂时隐藏
                    await store.dispatch('newRoutes', menus)
                    next({ path: '/index' })
                }()
            } else {
                let is404 = to.matched.some(record => {
                    if (record.meta.role) {
                        return record.meta.role.indexOf(store.getters.info.role) === -1
                    }
                })
                if (is404) {
                    next({ path: '/404' })
                    return false
                }
                next()
            }
        }
    } else {
        if (url === '/login' || url === '/register' || url === '/register/expert' || url === '/forget') {
            next()
            return;
        }
        next({ path: '/login' })
    }
})


new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/system/index/index.js